import {BigNumber} from "bignumber.js";

export const isNil = <T>(value: T | null | undefined): value is null | undefined => {
  return value === null || value === undefined;
};

export const isNotNil = <T>(value: T | null | undefined): value is T => {
  return !isNil(value);
};

export const assertNotNil: <T>(value: T | null | undefined) => asserts value is T = <T>(
  value: T | null | undefined
): asserts value is T => {
  if (isNil(value)) {
    throw Error("value is nil");
  }
};

export const assertCondition: (condition: boolean, message?: string) => asserts condition = (condition, message) => {
  if (!condition) {
    throw Error(message !== undefined ? `assertCondition: ${message}` : "condition is false");
  }
};

export const formatFractionPercent = (value: number | string | BigNumber) => {
  return new BigNumber(value).times(100).toFormat(1);
};
